export default class ApiSDKError extends Error {}
